import { END_POINTS } from '../helpers';
import { ColorData } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
  data: any;
};

export interface DashboardResponse {
  individualCount: number;
  dealerCount: number;
  addsCount: number;
}

// type GetColorResponse = {
//   count: number;
//   data: ColorData[];
// };

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    dashboardData: builder.query<CommonResponse & { data: DashboardResponse }, void>({
      query: () => ({
        url: `${END_POINTS.dashboard}`,
        method: 'GET',
      }),
    }),
    getGraphsData: builder.query<CommonResponse & { data: any }, { filter: string }>({
      query: ({ filter }) => ({
        url: `${END_POINTS.getGraphsData}?type=${filter}`,
        method: 'GET',
      }),
    }),
    getChangeGraphsData: builder.query<
      CommonResponse & { data: ColorData },
      { type: string; graphFor: number }
    >({
      query: ({ type, graphFor }) => ({
        url: `${END_POINTS.getChangeGraphsData}?type=${type}&graphFor=${graphFor}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyDashboardDataQuery,
  useLazyGetGraphsDataQuery,
  useLazyGetChangeGraphsDataQuery,
} = dashboardApi;
